/* eslint-disable react/prop-types */
import React from 'react';

import StarRating from '@zg-rentals/multibrand-ui/lib/StarRating';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import { STAR_MAP } from './controller';

import './style.scss';

class StarRatingWithText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      starDescription: STAR_MAP[props.defaultStarRating],
    };
  }

  handleStarClick = (numOfStars) => {
    this.setState({
      starDescription: STAR_MAP[numOfStars],
    });

    this.props.onClick(numOfStars);
  };

  render() {
    const { defaultStarRating } = this.props;
    const { starDescription } = this.state;

    return (
      <div className="StarRatingWithText">
        <div className="stacked-md">
          <StarRating size="36" stars={5} defaultIndex={defaultStarRating - 1} onClick={this.handleStarClick} />
        </div>
        <div className="stacked-md">
          <Text emphasize type="h2">
            {starDescription || '-'}
          </Text>
        </div>
      </div>
    );
  }
}

export default StarRatingWithText;
